<template>
  <div class="home">
    <Navigation />
    <Swiper />
    <div class="container">
      <Brand />
      <AboutUs />
      <MobileEnergyStation />
      <!-- <News/> -->
    </div>
    <!-- <Footer /> -->
    <ContactFloat />
  </div>
</template>

<script>
import axios from "axios";
import Navigation from "@/components/Navigation.vue";
import Swiper from "@/views/HomeComponents/Swiper.vue";
import AboutUs from "@/views/HomeComponents/AboutUs.vue";
import Brand from "@/views/HomeComponents/Brand.vue";
import MobileEnergyStation from "@/views/HomeComponents/MobileEnergyStation.vue";
// import News from '@/views/News.vue'
import Footer from "@/components/Footer.vue";
import ContactFloat from "@/components/ContactFloat.vue";
export default {
  name: "HomeView",
  components: {
    Navigation,
    Swiper,
    AboutUs,
    Brand,
    MobileEnergyStation,
    // News,
    Footer,
    ContactFloat,
  },
  data() {
    return {
      homeData: {},
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.container {
  width: 68%;
  margin: 0 auto;
}

@media screen and (max-width: 940px) {
  .container {
    width: 88%;
    margin: 0 auto;
  }
}
</style>